import { render, staticRenderFns } from "./AddMetadataModal.vue?vue&type=template&id=e4740810&scoped=true&"
import script from "./AddMetadataModal.vue?vue&type=script&lang=js&"
export * from "./AddMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMetadataModal.vue?vue&type=style&index=0&id=e4740810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4740810",
  null
  
)

export default component.exports